/* Bold Services — three full-width ACTS, each with accent-color hairline,
   oversized heavy sans titles, accent-block CTA buttons. */

import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { tenantHref } from "@/lib/tenant";

function startingPrice(s) {
  const tiers = Array.isArray(s?.tiers) ? s.tiers : [];
  const tp = tiers.map((t) => Number(t?.price)).filter((n) => Number.isFinite(n) && n > 0);
  if (tp.length) return Math.min(...tp);
  const n = Number(s?.price_from ?? s?.starting_price ?? s?.price);
  return Number.isFinite(n) && n > 0 ? n : null;
}

export default function BoldServices() {
  const [services, setServices] = useState([]);
  useEffect(() => {
    api.get("/services").then((r) => setServices(r.data || [])).catch(() => {});
  }, []);

  return (
    <div className="bg-[color:var(--tenant-bg,#FAF9F6)] text-[color:var(--tenant-fg,#0E0D0C)] min-h-screen pt-16 pb-24" data-testid="bold-services" style={{ fontFamily: "var(--tenant-sans)" }}>
      <div className="max-w-[1480px] mx-auto px-6 lg:px-12 pt-12">
        <div className="text-[10px] uppercase tracking-[0.45em] text-[color:var(--tenant-accent)] mb-3">
          Pricing · {services.length} acts
        </div>
        <h1 className="text-6xl lg:text-9xl font-extrabold uppercase leading-[0.92] tracking-tighter mb-16" style={{ fontFamily: "var(--tenant-sans)" }}>
          Services
        </h1>
      </div>

      {services.length === 0 ? (
        <p className="max-w-[1480px] mx-auto px-6 lg:px-12 uppercase tracking-[0.32em] text-[color:var(--tenant-fg,#0E0D0C)]/55 py-16">
          Acts being written.
        </p>
      ) : (
        services.map((s, i) => {
          const p = startingPrice(s);
          const num = String(i + 1).padStart(2, "0");
          return (
            <section
              key={s.id || s.slug}
              className="border-t-4 py-14 lg:py-20"
              style={{ borderColor: "var(--tenant-accent, #C9A961)" }}
              data-testid={`bold-service-${s.slug}`}
            >
              <div className="max-w-[1480px] mx-auto px-6 lg:px-12 grid grid-cols-1 lg:grid-cols-12 gap-10 items-start">
                <div className="lg:col-span-1 text-[10px] uppercase tracking-[0.45em] text-[color:var(--tenant-accent)]">
                  ACT {num}
                </div>
                <div className="lg:col-span-7">
                  <h2 className="text-4xl lg:text-6xl font-extrabold uppercase leading-[0.95] tracking-tighter" style={{ fontFamily: "var(--tenant-sans)" }}>
                    {s.name}
                  </h2>
                  <p className="mt-6 text-base lg:text-lg text-[color:var(--tenant-fg,#0E0D0C)]/75 max-w-2xl leading-relaxed">
                    {s.description || s.short_description || ""}
                  </p>
                </div>
                <div className="lg:col-span-4 lg:text-right">
                  <div className="text-4xl lg:text-6xl font-extrabold tabular-nums leading-none">
                    {p != null ? `$${p}` : "—"}
                  </div>
                  <Link
                    to={tenantHref(`/booking?service=${s.slug}`)}
                    className="inline-block mt-6 px-7 py-4 text-[11px] uppercase tracking-[0.32em] font-bold text-white hover:opacity-90 transition-opacity"
                    style={{ background: "var(--tenant-accent, #C9A961)" }}
                  >
                    Reserve →
                  </Link>
                </div>
              </div>
            </section>
          );
        })
      )}
    </div>
  );
}
